export default "__VITE_ASSET__DAR9yGZr__"